import { lowerCase } from 'lodash';

import type { ToldVia } from './types';

/** Between the parts of a meta line: "Dana Whitfield · sent 14:02 · read at run start". */
const SEPARATOR = ' · ';

/** User-facing copy of the log's conversation with Clive: the composer, the queue and Clive's reply. */
export const CONVERSATION_TEXTS = {
  SEPARATOR,

  /** On the handler's message: when they sent it, and how the run that read it was told it. */
  SENT_AT: (time: string): string => `sent ${time}`,
  TOLD_VIA: {
    run_start: 'read at run start',
    inbox: 'read mid-run',
  } satisfies Record<ToldVia, string>,
  /** The handler's message's link forward to the reply Clive gave it. */
  SEE_REPLY: 'See reply',

  /** The head of Clive's reply: "Reply · 14:05 · to Dana Whitfield's message at 14:02 · about: …". */
  REPLY: 'Reply',
  TO: 'to ',
  /** One of the messages the reply answers, as its link back to it reads. */
  MESSAGE_AT: (author: string | null, time: string): string =>
    author ? `${author}'s message at ${time}` : `the message at ${time}`,
  /** Between the messages the reply answers: "A, B and C". */
  LIST_SEPARATOR: ', ',
  AND: ' and ',
  ABOUT: 'about: ',
  /** The reply's chip while a question it raised waits on the handler. */
  WAITING_ON_ANSWER: 'Waiting on your answer',
  /** The foot of Clive's reply: how its run ended, in words, and the run's summary behind a toggle. */
  RUN_ENDED: (disposition: string | null): string =>
    disposition ? `Run ended${SEPARATOR}${lowerCase(disposition)}` : 'Run ended',
  SUMMARY: 'Summary',

  /** The caption of a question Clive raised in reply, with the time of the message where the log holds it. */
  QUESTION: 'Question',
  IN_RESPONSE_TO: (time: string | null): string =>
    time ? `in response to your message at ${time}` : 'in response to your message',

  /** The name of Clive's cursor at the foot of the log, while a run works; the cursor draws only its dots. */
  WORKING: 'Clive is working',

  /** The queue's header. */
  QUEUE_HEADER: 'Waiting for Clive',

  COMPOSER_PLACEHOLDER: 'Message Clive about this claim',
  /** Beside Send, in the composer's box, when the message did not go and its text is back in the field. */
  NOT_SENT: 'Not sent. Try again.',
  /** The queue's last row while its message is on its way to Clive, as a screen reader is told it. */
  SENDING_ROW: 'Sending',
};
